import { FieldArray, useFormikContext } from "formik";

import TextInput from "uicomponents/TextInput";
import RadioInput from "uicomponents/RadioInput";
import TextArea from "uicomponents/TextArea";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { BusinessDetailsFormType } from "pages/WorkersCompApplcation/utils/formType";
import { WCAppType } from "types";
import { useEffect } from "react";

interface RelatedEntitiesDetailsProps {
  applicationData: undefined | null | WCAppType;
  fieldRefs: React.MutableRefObject<{ [key: string]: HTMLInputElement | null }>;
}

const RelatedEntitiesDetails = ({
  applicationData,
  fieldRefs,
}: RelatedEntitiesDetailsProps): JSX.Element => {
  const relatedEntityLabels =
    sectionsQuestions["businessDetails"].questions.relatedEntities;
  const { values, setFieldValue } = useFormikContext<BusinessDetailsFormType>();

  useEffect(() => {
    if (values?.relatedEntities[0]?.reHasW2Employees === "No") {
      setFieldValue("relatedEntities[0].reHasOverlappingEmployees", "");
      setFieldValue("relatedEntities[0].reSharesLocation", "");
      setFieldValue("relatedEntities[0].reEin", "");
      setFieldValue("relatedEntities[0].reIsDependent", "");
    }
  }, [values?.relatedEntities, setFieldValue]);

  return (
    <div>
      <FieldArray
        name="relatedEntities"
        render={() => (
          <div>
            <TextInput
              name="relatedEntities[0].reName"
              type="string"
              label={relatedEntityLabels.entityName}
              fieldRefs={fieldRefs}
            />
            <TextInput
              name="relatedEntities[0].reDba"
              type="string"
              label={relatedEntityLabels.dba}
              required={false}
            />
            <TextArea
              name="relatedEntities[0].reDescription"
              label={relatedEntityLabels.description(values.companyName)}
              fieldRefs={fieldRefs}
            />
            <RadioInput
              name="relatedEntities[0].reHasW2Employees"
              label={relatedEntityLabels.hasW2Employees}
              options={["Yes", "No"]}
              fieldRefs={fieldRefs}
            />
            {values.relatedEntities[0].reHasW2Employees === "Yes" && (
              <>
                <TextInput
                  name="relatedEntities[0].reEin"
                  type="string"
                  label={relatedEntityLabels.ein}
                />
                <RadioInput
                  name="relatedEntities[0].reIsDependent"
                  label={relatedEntityLabels.isDependent}
                  options={["Yes", "No"]}
                />
                <RadioInput
                  name="relatedEntities[0].reHasOverlappingEmployees"
                  label={relatedEntityLabels.hasOverlappingEmployees(
                    values.companyName
                  )}
                  options={["Yes", "No"]}
                  fieldRefs={fieldRefs}
                />
                <RadioInput
                  name="relatedEntities[0].reSharesLocation"
                  label={relatedEntityLabels.sharesLocation}
                  options={["Yes", "No"]}
                  fieldRefs={fieldRefs}
                />
              </>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default RelatedEntitiesDetails;
